import { createFileRoute } from '@tanstack/react-router';

import { DelegatedUsersPage } from '@/features/delegated-users/components/DelegatedUsersPage';

export const Route = createFileRoute('/admin/users')({
  component: DelegatedUsersPage,
});
